import { render, staticRenderFns } from "./rotationset.vue?vue&type=template&id=2f2664b3&scoped=true&"
import script from "./rotationset.vue?vue&type=script&lang=js&"
export * from "./rotationset.vue?vue&type=script&lang=js&"
import style0 from "./rotationset.vue?vue&type=style&index=0&id=2f2664b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2664b3",
  null
  
)

export default component.exports